import {
  MiBox,
  MiIcon,
  MiLink,
  MiList,
  MiModalConfirm,
} from "@miplatform/components";
import {
  BUTTON_LABELS,
  ENTITY_NAMES,
  ICONS_WEB,
  PAGINATION,
  PERMISSIONS,
} from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { usePermissions } from "@mibuildweb/hooks";
import { useTheme } from "@mui/material";
import { AddWorkOrderTemplateModal } from "./AddWorkOrderTemplateModal";
import { useWorkOrderTemplatesTabViewModel } from "./useWorkOrderTemplatesTabViewModel";

export function WorkOrderTemplates({
  orderTemplate,
  refresh,
  workOrderTemplateModalOpen,
  closeWorkOrderTemplateModal = () => {},
}) {
  const {
    selectedWorkOrderTemplate,
    isDeleteModalOpen,
    deleteWorkOrderTemplate,
    openDeleteModal,
    closeDeleteModal,
    handleUpdateOrderTemplateWorkOrderTemplate,
  } = useWorkOrderTemplatesTabViewModel({
    orderTemplateId: orderTemplate.id,
    refresh,
  });

  const { hasPermission } = usePermissions();

  const theme = useTheme();

  const columns = [
    {
      field: "name",
      headerName: "Name",
      headerAlign: "left",
      align: "left",
      groupable: false,
      flex: 1,
      renderCell: hasPermission(PERMISSIONS.ORDER_TEMPLATE.UPDATE)
        ? ({ row: { id, index, workOrderTemplateId }, value }) => (
            <MiLink
              key={id}
              title={value}
              to={`/settings/order-management/work-order-types/${workOrderTemplateId}/details`}
              data-testid={`work-order-type-link-${index}`}
            />
          )
        : null,
    },
    {
      field: "shortName",
      headerName: "Short Name",
      groupable: false,
      headerAlign: "left",
      align: "left",
      flex: 1,
    },
  ];

  const getRowActions = (row) => [
    {
      text: BUTTON_LABELS.DELETE,
      onClick: () => {
        openDeleteModal(row);
      },
      renderIcon: () => (
        <MiIcon
          path={mdi[ICONS_WEB.TRASH_CAN]}
          color={theme.palette.red.main}
        />
      ),
      disabled: row.required,
    },
  ];

  return (
    <MiBox>
      <MiList
        columns={columns}
        data-testid="template-table"
        data={orderTemplate.workOrderTemplates || []}
        paginationMode={PAGINATION.CLIENT}
        getRowActions={getRowActions}
        initialState={{
          sorting: {
            sortModel: [{ field: "name", sort: "asc" }],
          },
        }}
      />
      <MiModalConfirm
        title="Confirm Delete"
        description={`Are you sure you want to delete: ${selectedWorkOrderTemplate?.name}?`}
        open={isDeleteModalOpen}
        handlePositive={deleteWorkOrderTemplate}
        textPositive={BUTTON_LABELS.DELETE}
        handleNegative={closeDeleteModal}
      />
      <AddWorkOrderTemplateModal
        orderTemplateId={orderTemplate.id}
        open={workOrderTemplateModalOpen}
        title={`Add ${ENTITY_NAMES.WORK_ORDER_TEMPLATE}`}
        buttonTitle="Update"
        onClose={closeWorkOrderTemplateModal}
        onSubmit={handleUpdateOrderTemplateWorkOrderTemplate}
      />
    </MiBox>
  );
}
